const ITEM_LEAD_TIME_AVAILABLE_NOW = 'available-now';

export { ITEM_LEAD_TIME_AVAILABLE_NOW };
